// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"_2EAnbwllJpr_14p9lNN4yA","collapse":"_3uVlsuaUOo6Kfy4lCuBx83"};